import ProductListContainer from "./ProductListContainer";
import ProductListStore from "./ProductListStore";

export default ProductListStore(ProductListContainer);